import { graphql } from '@generated/gql';

export const FETCH_STATIC_PAGE_WIDGET_CONFIGURATION_NAME =
  graphql(/** GraphQL */ `
  query staticPageWidgetConfigurationBreadcrumbFetchStaticPageWidgetConfigurationName(
    $staticPageWidgetConfigurationId: ObjectID!
  ) {
    fetchStaticPageWidgetConfiguration(
      staticPageWidgetConfigurationId: $staticPageWidgetConfigurationId
    ) {
      staticPageWidgetConfiguration {
        name
      }
    }
  }
`);
